// src/types/login.ts
var LOGIN_METHOD = /* @__PURE__ */ ((LOGIN_METHOD2) => {
  LOGIN_METHOD2["MANUAL"] = "MANUAL";
  LOGIN_METHOD2["NOSTR"] = "NOSTR";
  LOGIN_METHOD2["PRIVATE_KEY"] = "PRIVATE_KEY";
  LOGIN_METHOD2["EMAIL_MAGIC_LINK"] = "EMAIL_MAGIC_LINK";
  LOGIN_METHOD2["GOOGLE"] = "GOOGLE";
  LOGIN_METHOD2["GITHUB"] = "GITHUB";
  LOGIN_METHOD2["MICROSOFT"] = "MICROSOFT";
  return LOGIN_METHOD2;
})(LOGIN_METHOD || {});
var LOGIN_METHOD_NOSTR = [
  "NOSTR" /* NOSTR */,
  "PRIVATE_KEY" /* PRIVATE_KEY */,
  "MANUAL" /* MANUAL */
];
var LOGIN_METHOD_EMAIL_MAGIC_LINK = ["EMAIL_MAGIC_LINK" /* EMAIL_MAGIC_LINK */];
var LOGIN_METHOD_GOOGLE = ["GOOGLE" /* GOOGLE */];
var LOGIN_METHOD_GITHUB = ["GITHUB" /* GITHUB */];
var LOGIN_METHOD_MICROSOFT = ["MICROSOFT" /* MICROSOFT */];
var OFFICIAL_LOGIN_METHODS = [
  "NOSTR" /* NOSTR */,
  "EMAIL_MAGIC_LINK" /* EMAIL_MAGIC_LINK */,
  "GOOGLE" /* GOOGLE */,
  "GITHUB" /* GITHUB */,
  "MICROSOFT" /* MICROSOFT */
];
var loginMethodFromType = (type) => {
  switch (type) {
    case "NOSTR":
      return "NOSTR" /* NOSTR */;
    case "EMAIL_MAGIC_LINK":
      return "EMAIL_MAGIC_LINK" /* EMAIL_MAGIC_LINK */;
    case "GOOGLE":
      return "GOOGLE" /* GOOGLE */;
    case "GITHUB":
      return "GITHUB" /* GITHUB */;
    case "MICROSOFT":
      return "MICROSOFT" /* MICROSOFT */;
    default:
      return void 0;
  }
};
var loginMethodFromTypeOrThrow = (type) => {
  const method = loginMethodFromType(type);
  if (!method) {
    throw new Error(`Unsupported login method type: ${type}`);
  }
  return method;
};
var isOfficialLoginMethod = (type) => {
  const loginMethod = loginMethodFromType(type);
  return loginMethod ? OFFICIAL_LOGIN_METHODS.includes(loginMethod) : false;
};

// src/types/api.ts
function makeUrl(url, params) {
  if (params) {
    const entries = Object.entries(params).filter(([, value]) => value !== void 0).map(([key, value]) => [key, String(value)]);
    const search = new URLSearchParams(entries).toString();
    return search ? `${url}?${search}` : url;
  }
  return url;
}

// src/types/rusty-common/generated.ts
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["BTC"] = "btc";
  Currency2["EUR"] = "eur";
  Currency2["USDT"] = "usdt";
  Currency2["DAI"] = "dai";
  Currency2["USD"] = "usd";
  Currency2["AED"] = "aed";
  Currency2["ARS"] = "ars";
  Currency2["AUD"] = "aud";
  Currency2["BDT"] = "bdt";
  Currency2["BGN"] = "bgn";
  Currency2["BOB"] = "bob";
  Currency2["BRL"] = "brl";
  Currency2["CAD"] = "cad";
  Currency2["CHF"] = "chf";
  Currency2["CLP"] = "clp";
  Currency2["CNY"] = "cny";
  Currency2["COP"] = "cop";
  Currency2["CRC"] = "crc";
  Currency2["CZK"] = "czk";
  Currency2["DKK"] = "dkk";
  Currency2["DOP"] = "dop";
  Currency2["EGP"] = "egp";
  Currency2["FJD"] = "fjd";
  Currency2["GBP"] = "gbp";
  Currency2["HKD"] = "hkd";
  Currency2["HRK"] = "hrk";
  Currency2["HUF"] = "huf";
  Currency2["IDR"] = "idr";
  Currency2["ILS"] = "ils";
  Currency2["INR"] = "inr";
  Currency2["JPY"] = "jpy";
  Currency2["KES"] = "kes";
  Currency2["KRW"] = "krw";
  Currency2["LKR"] = "lkr";
  Currency2["MAD"] = "mad";
  Currency2["MXN"] = "mxn";
  Currency2["MYR"] = "myr";
  Currency2["NGN"] = "ngn";
  Currency2["NOK"] = "nok";
  Currency2["NZD"] = "nzd";
  Currency2["PEN"] = "pen";
  Currency2["PHP"] = "php";
  Currency2["PKR"] = "pkr";
  Currency2["PLN"] = "pln";
  Currency2["QAR"] = "qar";
  Currency2["RON"] = "ron";
  Currency2["RUB"] = "rub";
  Currency2["SAR"] = "sar";
  Currency2["SEK"] = "sek";
  Currency2["SGD"] = "sgd";
  Currency2["THB"] = "thb";
  Currency2["TRY"] = "try";
  Currency2["TWD"] = "twd";
  Currency2["UAH"] = "uah";
  Currency2["VND"] = "vnd";
  Currency2["ZAR"] = "zar";
  return Currency2;
})(Currency || {});
var DepositStatus = /* @__PURE__ */ ((DepositStatus2) => {
  DepositStatus2["PENDING"] = "PENDING";
  DepositStatus2["DONE"] = "DONE";
  DepositStatus2["ERROR"] = "ERROR";
  return DepositStatus2;
})(DepositStatus || {});
var DepositProvider = /* @__PURE__ */ ((DepositProvider2) => {
  DepositProvider2["STRIPE"] = "STRIPE";
  DepositProvider2["COINBASE"] = "COINBASE";
  return DepositProvider2;
})(DepositProvider || {});
var SubscriptionStatus = /* @__PURE__ */ ((SubscriptionStatus2) => {
  SubscriptionStatus2["ACTIVE"] = "ACTIVE";
  SubscriptionStatus2["GracePeriod"] = "GracePeriod";
  SubscriptionStatus2["EXPIRED"] = "EXPIRED";
  SubscriptionStatus2["CANCELLED"] = "CANCELLED";
  return SubscriptionStatus2;
})(SubscriptionStatus || {});

// src/types/rusty-common/axios-errors.ts
function hasFieldValidationError(error) {
  return Boolean(
    error?.isAxiosError && error?.response?.data?.error === "validation_error"
  );
}
function axiosFieldValidationErrorToFormErrors(validationError) {
  const responseData = validationError.response?.data;
  if (responseData.error !== "validation_error") {
    return {};
  }
  const formErrors = {};
  responseData.errors.forEach((fieldError) => {
    if (fieldError.field && fieldError.message) {
      formErrors[fieldError.field] = fieldError.message;
    }
  });
  return formErrors;
}

// src/auth.ts
import axios from "axios";
import { decodeJwt } from "jose";

// src/utils/billing.ts
function balanceNextHigher(bal) {
  if (bal[1] === 0) {
    return bal[1];
  }
  return bal[1] / 1e5;
}
function formatCurrency(bal) {
  return `${bal[0].toUpperCase()} ${balanceNextHigher(bal)}`;
}

// src/utils/error-title.ts
var getErrorTitle = (error) => {
  if (error.response) {
    const status = error.response.status;
    switch (status) {
      case 400:
        return "Bad Request";
      case 401:
        return "Authentication Required";
      case 403:
        return "Access Denied";
      case 404:
        return "Not Found";
      case 409:
        return "Conflict";
      case 422:
        return "Validation Error";
      case 500:
        return "Server Error";
      default:
        return `Error ${status}`;
    }
  } else if (error.request) {
    return "Network Error";
  }
  return "API Error";
};

// src/constants.ts
var LOCAL_STORAGE_KEY = "rusty.session";

// src/utils/localstore.ts
function hasFutureExpiry(expiresAt, threshold) {
  const now = Math.round(Date.now() / 1e3);
  return expiresAt > now + threshold;
}
function getLsLoginSession(storageKey = LOCAL_STORAGE_KEY) {
  console.debug("getLoginSession");
  const sessionJson = localStorage.getItem(`${storageKey}.data`);
  if (sessionJson) {
    return JSON.parse(sessionJson);
  }
  return null;
}
function getLsSession(storageKey = LOCAL_STORAGE_KEY) {
  console.debug("getLsSession");
  const sessionJson = localStorage.getItem(`${storageKey}.data`);
  if (sessionJson) {
    const session = JSON.parse(sessionJson);
    if (session.accessTokenExpiresAt && typeof session.accessTokenExpiresAt === "string") {
      session.accessTokenExpiresAt = parseInt(session.accessTokenExpiresAt, 10);
    }
    if (session.refreshTokenExpiresAt && typeof session.refreshTokenExpiresAt === "string") {
      session.refreshTokenExpiresAt = parseInt(session.refreshTokenExpiresAt, 10);
    }
    if (session.expiresAt && typeof session.expiresAt === "string") {
      session.expiresAt = parseInt(session.expiresAt, 10);
    }
    if (!session.accessTokenExpiresAt || !session.refreshTokenExpiresAt || !session.expiresAt) {
      console.warn("Session data is incomplete, clearing local storage");
      if (session.accessToken && session.refreshToken) {
        try {
          const decoded = decodeSessionTokens({
            access_token: session.accessToken,
            refresh_token: session.refreshToken
          });
          session.accessTokenExpiresAt = decoded.accessTokenExpiresAt;
          session.refreshTokenExpiresAt = decoded.refreshTokenExpiresAt;
          setLsSession(session);
        } catch (error) {
          console.error("Failed to decode session tokens:", error);
          clearLsSession();
          return null;
        }
      } else {
        console.error("Session tokens are missing, clearing local storage");
        clearLsSession();
        return null;
      }
    }
    if (!session.isLoggedIn || !hasFutureExpiry(session.expiresAt, 300)) {
      console.warn("Session is not valid, clearing local storage");
      clearLsSession();
      return null;
    }
    return session;
  }
  return null;
}
function setLsSession(session, storageKey = LOCAL_STORAGE_KEY) {
  console.debug("setLsSession", session);
  localStorage.setItem(`${storageKey}.data`, JSON.stringify(session));
}
function clearLsSession(storageKey = LOCAL_STORAGE_KEY) {
  console.debug("clearLsSession");
  localStorage.removeItem(`${storageKey}.data`);
}

// src/utils/make-auth-headers.ts
function makeAuthHeaders(token) {
  return {
    Authorization: `Bearer ${token}`
  };
}

// src/utils/nostr.ts
import { decodeNostrPrivateKeyString } from "@nostr-ts/common";
function decodeNostrPrivateKey(privateKey) {
  if (privateKey.startsWith("nsec")) {
    return decodeNostrPrivateKeyString(`nostr:${privateKey}`);
  } else if (privateKey.startsWith("nostr:")) {
    return decodeNostrPrivateKeyString(privateKey);
  } else {
    return privateKey;
  }
}
function decodeNostrPublicKey(publicKey) {
  if (publicKey.startsWith("npub")) {
    return publicKey;
  } else if (publicKey.startsWith("nostr:")) {
    return publicKey.slice(6);
  } else {
    return publicKey;
  }
}

// src/utils/rss-parser.ts
import { XMLParser } from "fast-xml-parser";
function parseRSS(xml) {
  const parser = new XMLParser({
    ignoreAttributes: false,
    attributeNamePrefix: "@_",
    parseAttributeValue: true
  });
  const result = parser.parse(xml);
  if (result.feed?.entry) {
    result.feed.entry = result.feed.entry.map((entry) => ({
      ...entry,
      category: Array.isArray(entry.category) ? entry.category.map((cat) => cat["@_term"]) : [entry.category["@_term"]],
      link: entry.link?.["@_href"] || "",
      summary: typeof entry.summary === "object" && entry.summary["#text"] ? entry.summary["#text"] : entry.summary,
      content: typeof entry.content === "object" && entry.content["#text"] ? entry.content["#text"] : entry.content,
      title: typeof entry.title === "object" && entry.title["#text"] ? entry.title["#text"] : entry.title
    }));
  }
  return result;
}

// src/auth.ts
var decodeSessionTokens = (cr) => {
  const accessTokenDecoded = decodeJwt(cr.access_token);
  const refreshTokenDecoded = decodeJwt(cr.refresh_token);
  if (!accessTokenDecoded.exp || !refreshTokenDecoded.exp) {
    throw new Error("Invalid token");
  }
  return {
    accessTokenExpiresAt: accessTokenDecoded.exp,
    refreshTokenExpiresAt: refreshTokenDecoded.exp
  };
};
var RustyAuth = class {
  constructor({ baseUrl, timeout, useLocalStore, localStorageKey }) {
    this.useLocalStore = false;
    this.refreshAttempts = 0;
    this.maxRefreshAttempts = 3;
    this.lastRefreshAttempt = 0;
    this.baseUrl = baseUrl || "https://api.checkoutbay.com/v1";
    this.timeout = timeout || 5e3;
    this.useLocalStore = useLocalStore || false;
    if (localStorageKey) {
      this.localStorageKey = localStorageKey;
    } else {
      throw new Error("localStorageKey is required");
    }
    this.client = axios.create({
      baseURL: this.baseUrl,
      timeout: this.timeout,
      headers: {
        "Content-Type": "application/json"
      }
    });
    this.session = {
      isLoggedIn: false
    };
    console.info(`[api] => baseUrl: ${this.baseUrl}`);
    if (this.useLocalStore) {
      console.info("[api] => Using local storage for session management");
      const storedSession = getLsSession(this.localStorageKey);
      if (storedSession) {
        this.session = storedSession;
        console.debug("[api] => Loaded session from local storage", this.session);
      } else {
        console.debug("[api] => No session found in local storage");
      }
    }
  }
  getSession() {
    return this.session;
  }
  setSession(session) {
    this.session = session;
    this.refreshAttempts = 0;
    this.lastRefreshAttempt = 0;
    if (this.useLocalStore) {
      setLsSession(session, this.localStorageKey);
    }
  }
  clearSession() {
    if (this.useLocalStore) {
      clearLsSession(this.localStorageKey);
    }
    this.session = { isLoggedIn: false };
    this.refreshAttempts = 0;
    this.lastRefreshAttempt = 0;
  }
  hasValidSession(threshold = 300) {
    if (!this.session.isLoggedIn || !this.session.refreshTokenExpiresAt) {
      return false;
    }
    return hasFutureExpiry(this.session.refreshTokenExpiresAt, threshold);
  }
  hasValidAccessToken(threshold = 300) {
    if (!this.session.isLoggedIn) {
      console.warn("AUTH: Session is not logged in");
      return false;
    }
    if (this.session.accessTokenExpiresAt === void 0) {
      console.warn("AUTH: Access token expiration time is not defined");
      return false;
    }
    if (!hasFutureExpiry(this.session.accessTokenExpiresAt, threshold)) {
      console.warn(`AUTH: Access token is not valid, expires at ${this.session.accessTokenExpiresAt}`);
      return false;
    }
    return true;
  }
  needsRefresh(threshold = 300) {
    return this.hasValidSession(threshold) && !this.hasValidAccessToken(threshold);
  }
  getUserId() {
    if (!this.session.userId) {
      throw new Error("No user id");
    }
    return this.session.userId;
  }
  getAccessToken() {
    if (!this.hasValidAccessToken()) {
      throw new Error("No access token");
    }
    return this.session.accessToken;
  }
  getRefreshToken() {
    if (!this.hasValidSession(30)) {
      throw new Error("AUTH: Session is invalid or expired, cannot get refresh token");
    }
    return this.session.refreshToken;
  }
  async login(loginRequest) {
    const referralCode = localStorage.getItem("pendingReferralCode");
    if (referralCode) {
      loginRequest.content.referral_code = referralCode;
    }
    switch (loginRequest.type) {
      case "NOSTR" /* NOSTR */:
        this.setSession({
          isLoggedIn: false,
          publicKey: loginRequest.content.public_key,
          method: "NOSTR" /* NOSTR */
        });
        break;
      case "EMAIL_MAGIC_LINK" /* EMAIL_MAGIC_LINK */:
        this.setSession({
          isLoggedIn: false,
          method: "EMAIL_MAGIC_LINK" /* EMAIL_MAGIC_LINK */
        });
        break;
      case "GOOGLE" /* GOOGLE */:
        this.setSession({
          isLoggedIn: false,
          method: "GOOGLE" /* GOOGLE */
        });
        break;
      case "GITHUB" /* GITHUB */:
        this.setSession({
          isLoggedIn: false,
          method: "GITHUB" /* GITHUB */
        });
        break;
      default:
        throw new Error(`Unsupported login method: ${loginRequest.type}`);
    }
    const { data } = await this.client.post(
      "/login",
      loginRequest
    );
    return data;
  }
  async loginChallenge(props) {
    const { data } = await this.client.post(
      "/login/challenge",
      props
    );
    const newSession = {
      isLoggedIn: true,
      userId: data.user_id,
      accessToken: data.access_token,
      refreshToken: data.refresh_token,
      expiresAt: data.expires_at,
      ...decodeSessionTokens(data),
      method: props.type
    };
    if (props.type === "NOSTR" /* NOSTR */) {
      console.log("NOSTR login detected: Looking for public key in local storage");
      if (this.useLocalStore) {
        console.debug("Using local storage for session management");
        const savedSession = getLsLoginSession(this.localStorageKey);
        if (savedSession?.publicKey) {
          console.debug("Found public key in local storage, setting it in session");
          newSession.publicKey = savedSession.publicKey;
        } else {
          console.warn(`No public key found in local storage for NOSTR login (${JSON.stringify(savedSession)})`);
        }
      }
    }
    this.setSession(newSession);
    return data;
  }
  async refresh() {
    if (this.refreshAttempts >= this.maxRefreshAttempts) {
      console.warn(`AUTH: Maximum refresh attempts (${this.maxRefreshAttempts}) exceeded, clearing session`);
      this.clearSession();
      throw new Error("AUTH: Maximum refresh attempts exceeded, session cleared");
    }
    const now = Date.now();
    const timeSinceLastAttempt = now - this.lastRefreshAttempt;
    const backoffDelay = Math.pow(2, this.refreshAttempts) * 1e3;
    if (timeSinceLastAttempt < backoffDelay) {
      const remainingDelay = backoffDelay - timeSinceLastAttempt;
      console.debug(`AUTH: Backoff active, waiting ${remainingDelay}ms before retry`);
      await new Promise((resolve) => setTimeout(resolve, remainingDelay));
    }
    this.refreshAttempts++;
    this.lastRefreshAttempt = Date.now();
    try {
      const { data } = await this.client.post(
        "/login/refresh",
        {
          access_token: this.session.accessToken,
          refresh_token: this.getRefreshToken()
        }
      );
      const newSession = {
        isLoggedIn: true,
        userId: data.user_id,
        accessToken: data.access_token,
        refreshToken: data.refresh_token,
        expiresAt: data.expires_at,
        ...decodeSessionTokens(data),
        method: this.session.method
      };
      if (this.session.publicKey) {
        newSession.publicKey = this.session.publicKey;
      }
      this.setSession(newSession);
      console.info("AUTH: Token refresh successful");
      return data;
    } catch (error) {
      console.warn(`AUTH: Refresh attempt ${this.refreshAttempts}/${this.maxRefreshAttempts} failed`, error);
      const isAuthError = error?.response?.status === 401 || error?.response?.status === 403 || error?.response?.status === 404;
      if (isAuthError) {
        console.warn("AUTH: Authentication error detected, clearing session immediately");
        this.clearSession();
        throw new Error("AUTH: Authentication failed, session cleared");
      }
      if (this.hasValidSession(300)) {
        console.debug("AUTH: Refresh failed but session still valid, will retry later");
        return void 0;
      }
      console.warn("AUTH: Session no longer valid, clearing");
      this.clearSession();
      throw new Error("AUTH: Session expired, cleared");
    }
  }
  async logout() {
    if (this.hasValidAccessToken()) {
      try {
        await this.client.post(
          "/a/logout",
          {},
          {
            headers: makeAuthHeaders(this.getAccessToken())
          }
        );
      } catch (error) {
        console.error("Logout failed:", error);
      }
    }
    this.clearSession();
  }
};

// src/api-keys.ts
var RustyApiKeys = class {
  constructor({ client }) {
    this.client = client;
  }
  async createApiKey(request, accessToken) {
    const result = await this.client.post(
      "/a/api-keys",
      request,
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async listApiKeys(accessToken) {
    const result = await this.client.get(
      "/a/api-keys",
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async updateApiKey(id, request, accessToken) {
    const result = await this.client.put(
      `/a/api-keys/${id}`,
      request,
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async deleteApiKey(id, accessToken) {
    const result = await this.client.delete(
      `/a/api-keys/${id}`,
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async getApiKeyUsage(id, accessToken) {
    const result = await this.client.get(
      `/a/api-keys/${id}/usage`,
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
};

// src/deposit.ts
var RustyDeposit = class {
  constructor({ client }) {
    this.client = client;
  }
  async getAccountMovements(query, accessToken) {
    let url = `/a/movements`;
    if (query) {
      url += `?${new URLSearchParams(query)}`;
    }
    const result = await this.client.get(url, { headers: makeAuthHeaders(accessToken) });
    return result.data;
  }
  async getAccountBalance(accessToken) {
    const result = await this.client.get(
      "/a/balance",
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async getDeposits(query, accessToken) {
    let url = `/a/deposits`;
    if (query) {
      url += `?${new URLSearchParams(query)}`;
    }
    const result = await this.client.get(url, { headers: makeAuthHeaders(accessToken) });
    return result.data;
  }
  async getDeposit(id, accessToken) {
    const result = await this.client.get(
      `/a/deposits/${id}`,
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async newDeposit(deposit, accessToken) {
    const result = await this.client.post("/a/deposits", deposit, { headers: makeAuthHeaders(accessToken) });
    return result.data;
  }
};

// src/subscription.ts
var RustySubscription = class {
  constructor({ client }) {
    this.client = client;
  }
  async getSubscriptionPlans() {
    const result = await this.client.get(
      "/subscriptions/plans"
    );
    return result.data;
  }
  async getCurrentSubscription(accessToken) {
    try {
      const result = await this.client.get(
        "/a/subscriptions/current",
        { headers: makeAuthHeaders(accessToken) }
      );
      return result.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }
  async subscribeToplan(planId, accessToken) {
    const result = await this.client.post(
      `/a/subscriptions/${planId}`,
      {},
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async cancelSubscription(accessToken) {
    const result = await this.client.delete(
      "/a/subscriptions",
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async getSubscriptionUsage(accessToken) {
    const result = await this.client.get(
      "/a/subscriptions/usage",
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async createCustomerPortalSession(accessToken) {
    const result = await this.client.post(
      "/a/subscriptions/portal",
      {},
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
};

// src/subscription-utils.ts
function isCurrentPlan(planId, currentSubscription) {
  return currentSubscription?.plan_id === planId && currentSubscription?.status?.toLowerCase() === "active";
}
function isNextPlan(planId, currentSubscription) {
  return currentSubscription?.next_plan_id === planId && currentSubscription?.next_plan_id !== currentSubscription?.plan_id;
}
function hasNextPlan(currentSubscription) {
  return Boolean(
    currentSubscription?.next_plan_id && currentSubscription.next_plan_id !== currentSubscription.plan_id
  );
}
function getNextPlan(currentSubscription, subscriptionPlans) {
  if (!currentSubscription?.next_plan_id || !subscriptionPlans) {
    return null;
  }
  return subscriptionPlans.find((p) => p.id === currentSubscription.next_plan_id) || null;
}
function getCurrentPlan(currentSubscription, subscriptionPlans) {
  if (!currentSubscription?.plan_id || !subscriptionPlans) {
    return null;
  }
  const planId = currentSubscription.plan_id || currentSubscription.plan_name;
  return subscriptionPlans.find((p) => p.id === planId || p.name === planId) || null;
}
function isPaidPlan(currentSubscription, subscriptionPlans) {
  if (!currentSubscription?.plan_id && !currentSubscription?.plan_name) {
    return false;
  }
  const plan = getCurrentPlan(currentSubscription, subscriptionPlans);
  return Boolean(plan && !plan.is_free_plan);
}
function getPlanDisplayName(currentSubscription) {
  return currentSubscription?.plan_name || currentSubscription?.plan_id || "Unknown Plan";
}
function getStatusColor(status) {
  const normalizedStatus = status.toLowerCase();
  switch (normalizedStatus) {
    case "active":
      return "green";
    case "canceled":
      return "red";
    case "past_due":
      return "orange";
    case "incomplete":
      return "yellow";
    default:
      return "gray";
  }
}

// src/referral.ts
var RustyReferral = class {
  constructor({ client }) {
    this.client = client;
  }
  async getReferralCode(accessToken) {
    const result = await this.client.get(
      "/a/referrals/code",
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async getReferralStats(accessToken) {
    const result = await this.client.get(
      "/a/referrals/stats",
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async getReferralHistory(accessToken) {
    const result = await this.client.get(
      "/a/referrals/history",
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
};

// src/verified-emails.ts
var RustyVerifiedEmails = class {
  constructor({ client }) {
    this.client = client;
  }
  async newVerifiedEmail(data, accessToken) {
    await this.client.post(
      "/a/emails/verify",
      data,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
  }
  async verifyVerifiedEmail(id, accessToken) {
    await this.client.post(
      "/a/emails/verify/retry",
      { verified_email_id: id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
  }
  async deleteVerifiedEmail(id, accessToken) {
    await this.client.delete(
      `/a/emails/${id}`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
  }
  async setAccountEmail(id, accessToken) {
    await this.client.put(
      `/a/emails/${id}/set-account-email`,
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
  }
  async getVerifiedEmails(accessToken) {
    const response = await this.client.get(
      "/a/emails",
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    return response.data;
  }
};
export {
  Currency,
  DepositProvider,
  DepositStatus,
  LOGIN_METHOD,
  LOGIN_METHOD_EMAIL_MAGIC_LINK,
  LOGIN_METHOD_GITHUB,
  LOGIN_METHOD_GOOGLE,
  LOGIN_METHOD_MICROSOFT,
  LOGIN_METHOD_NOSTR,
  OFFICIAL_LOGIN_METHODS,
  RustyApiKeys,
  RustyAuth,
  RustyDeposit,
  RustyReferral,
  RustySubscription,
  RustyVerifiedEmails,
  SubscriptionStatus,
  axiosFieldValidationErrorToFormErrors,
  balanceNextHigher,
  clearLsSession,
  decodeNostrPrivateKey,
  decodeNostrPublicKey,
  decodeSessionTokens,
  formatCurrency,
  getCurrentPlan,
  getErrorTitle,
  getLsLoginSession,
  getLsSession,
  getNextPlan,
  getPlanDisplayName,
  getStatusColor,
  hasFieldValidationError,
  hasFutureExpiry,
  hasNextPlan,
  isCurrentPlan,
  isNextPlan,
  isOfficialLoginMethod,
  isPaidPlan,
  loginMethodFromType,
  loginMethodFromTypeOrThrow,
  makeAuthHeaders,
  makeUrl,
  parseRSS,
  setLsSession
};
//# sourceMappingURL=index.js.map